import { useCallback } from 'react';
import { create } from 'zustand';
const usePendingContactEmailUpdatesStore = create((set)=>({
        pendingUserIds: new Set(),
        markPending: (userId)=>set((state)=>{
                const next = new Set(state.pendingUserIds);
                next.add(userId);
                return {
                    pendingUserIds: next
                };
            }),
        markComplete: (userId)=>set((state)=>{
                if (!state.pendingUserIds.has(userId)) return state;
                const next = new Set(state.pendingUserIds);
                next.delete(userId);
                return {
                    pendingUserIds: next
                };
            })
    }));
export const usePendingContactEmailUpdates = ()=>{
    const pendingUserIds = usePendingContactEmailUpdatesStore((state)=>state.pendingUserIds);
    const markPending = usePendingContactEmailUpdatesStore((state)=>state.markPending);
    const isPending = useCallback((userId)=>pendingUserIds.has(userId), [
        pendingUserIds
    ]);
    return {
        isPending,
        markPending
    };
};
export const useIsContactEmailUpdateInProgress = (userId)=>{
    const { isPending } = usePendingContactEmailUpdates();
    return userId != null && isPending(userId);
};
export const markContactEmailUpdatePending = (userId)=>usePendingContactEmailUpdatesStore.getState().markPending(userId);
export const markContactEmailUpdateComplete = (userId)=>usePendingContactEmailUpdatesStore.getState().markComplete(userId);
export const isContactEmailUpdatePending = (userId)=>usePendingContactEmailUpdatesStore.getState().pendingUserIds.has(userId);
export const resetPendingContactEmailUpdatesForTests = ()=>usePendingContactEmailUpdatesStore.setState({
        pendingUserIds: new Set()
    });
